/** The list of available user roles. */
export const userRoles = [
    'admin',
    'systemadmin',
    'teamlead',
    'agent',
    'enduser',
];
